<template>
  <div
    class="
      is-teacher flex min-h-[120svh] w-full flex-col justify-between bg-white
      max-md:pb-navbar-height
      md:pt-navbar-height
    "
  >
    <Tab />
    <TeacherNavigationDesktop v-if="isLargeScreen" id="jump-navigation" />

    <slot />
    
    <TeacherNavigationMobile v-if="!isLargeScreen" />
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
const icon = useFavicon()

icon.value = '/favicon-teacher.svg'

const isLargeScreen = useMediaQuery('(min-width: 810px)')
</script>
